<template>
  <section>
    <div>
      退出登录
    </div>
  </section>
</template>
<script>
export default {
  props: {},
  data() {
    return {};
  },
  watch: {},
  components: {},
  async mounted() {},
  methods: {},
  created() {
    // console.log("aaa", this, this.$router);
  }
};
</script>
<style lang="less" scope></style>
